import { useState } from "react";
import api from "../api/client";
import { hashPassword } from "../api/crypto";

export default function Login({ onLogin }) {
  const [form, setForm]     = useState({ email: "", password: "" });
  const [error, setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // Hashea la contraseña en el browser antes de enviar
      const hashed = await hashPassword(form.password);

      // Llama al BFF — el JWT nunca llega al browser
      const { data } = await api.post("/api/auth", {
        email: form.email,
        password: hashed,
      });

      onLogin(data.usuario);
    } catch (err) {
      if (err.response?.status === 429) {
        setError("Demasiados intentos. Espera un minuto.");
      } else if (err.response?.status === 401 || err.response?.status === 403) {
        setError(err.response.data?.detail || "Credenciales incorrectas o acceso denegado.");
      } else {
        setError("Error de conexión con el servidor.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "linear-gradient(135deg, #0A1128 0%, #1a1f4e 60%, #0A1128 100%)" }}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-8">

        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-1 text-2xl font-black mb-2">
            <span className="text-indigo-600">Tu</span>
            <span className="text-gray-900">Catalogo</span>
            <span className="text-orange-500">.net</span>
          </div>
          <div className="inline-block bg-red-100 text-red-700 text-xs font-bold px-3 py-1 rounded-full tracking-wider uppercase">
            Portal Administrativo
          </div>
          <p className="text-gray-400 text-sm mt-3">Acceso restringido — solo administradores del sistema</p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Correo</label>
            <input
              type="email" required autoComplete="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="admin@tucatalogo.net"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
            <input
              type="password" required autoComplete="current-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit" disabled={loading}
            className="w-full bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white font-semibold py-2.5 rounded-lg transition-colors text-sm">
            {loading ? "Verificando..." : "Ingresar al panel"}
          </button>
        </form>
      </div>
    </div>
  );
}
